<template>
  <div class="create-po-view">
    <div class="page-header">
      <div class="header-left">
        <button class="back-btn" @click="handleCancel">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
        </button>
        <div class="header-info">
          <h1 class="page-heading">Nouvelle commande d'achat</h1>
          <p class="page-subtitle">Créez une commande fournisseur et gérez votre stock</p>
        </div>
      </div>
      <div class="actions">
        <button class="secondary-btn" @click="handleCancel">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
          Annuler
        </button>
        <button class="primary-btn" :disabled="isSubmitting || items.length === 0" @click="handleSubmit">
          <span v-if="isSubmitting" class="spinner-small"></span>
          <template v-else>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            Enregistrer
          </template>
        </button>
      </div>
    </div>

    <div class="layout">
      <div class="left-column">
        <div class="progress-indicator">
          <div class="progress-step" :class="{ active: true, completed: form.supplier_id }">
            <div class="step-number">1</div>
            <div class="step-info">
              <span class="step-title">Fournisseur</span>
              <span class="step-desc">Sélectionnez un fournisseur</span>
            </div>
          </div>
          <div class="progress-line" :class="{ completed: form.supplier_id }"></div>
          <div class="progress-step" :class="{ active: form.supplier_id, completed: items.length > 0 }">
            <div class="step-number">2</div>
            <div class="step-info">
              <span class="step-title">Produits</span>
              <span class="step-desc">Ajoutez les articles</span>
            </div>
          </div>
          <div class="progress-line" :class="{ completed: items.length > 0 }"></div>
          <div class="progress-step" :class="{ active: items.length > 0 }">
            <div class="step-number">3</div>
            <div class="step-info">
              <span class="step-title">Validation</span>
              <span class="step-desc">Finalisez la commande</span>
            </div>
          </div>
        </div>

        <div class="card supplier-card">
          <!-- <div class="card-header">
            <div class="card-icon supplier-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <div class="card-title-group">
              <h2 class="card-title">Informations fournisseur</h2>
              <p class="card-subtitle">Sélectionnez le fournisseur et définissez les détails</p>
            </div>
          </div> -->

          <div class="form-grid">
            <div class="form-group full-width">
              <label>
                Fournisseur
                <span class="required">*</span>
              </label>
              <div class="supplier-search-container">
                <div class="supplier-search-input-wrapper" :class="{ 'has-value': form.supplier_id }">
                  <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  </svg>
                  <input ref="supplierInput" type="text" v-model="supplierSearch" class="supplier-search-input"
                    placeholder="Rechercher un fournisseur..." @input="searchSuppliers"
                    @focus="showSupplierDropdown = true" />
                  <button v-if="supplierSearch" @click="clearSupplierSelection" class="clear-search-btn" type="button">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                  <div v-if="form.supplier_id" class="selected-indicator">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </div>
                </div>
                <transition name="dropdown">
                  <div v-if="showSupplierDropdown && supplierSuggestions.length > 0" class="supplier-dropdown">
                    <div v-for="s in supplierSuggestions" :key="s.id" class="supplier-option"
                      :class="{ selected: form.supplier_id === s.id }" @click="selectSupplier(s)">
                      <div class="supplier-option-content">
                        <div class="supplier-name">{{ s.name }}</div>
                        <div class="supplier-meta" v-if="s.phone || s.email">
                          <span v-if="s.phone">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path
                                d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                              </path>
                            </svg>
                            {{ s.phone }}
                          </span>
                          <span v-if="s.email">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z">
                              </path>
                              <polyline points="22,6 12,13 2,6"></polyline>
                            </svg>
                            {{ s.email }}
                          </span>
                        </div>
                      </div>
                      <svg v-if="form.supplier_id === s.id" class="check-icon" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                  </div>
                </transition>
                <transition name="fade">
                  <div v-if="showSupplierDropdown && supplierSuggestions.length === 0 && supplierSearch.trim()"
                    class="no-suppliers-found">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="8" x2="12" y2="12"></line>
                      <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                    <p>Aucun fournisseur trouvé</p>
                  </div>
                </transition>
              </div>
              <span v-if="errors.supplier_id" class="field-error">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                {{ errors.supplier_id }}
              </span>
            </div>

            <div class="form-group">
              <label>
                Date de commande
                <span class="required">*</span>
              </label>
              <div class="input-with-icon">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                <input type="date" v-model="form.order_date" />
              </div>
              <span v-if="errors.order_date" class="field-error">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                {{ errors.order_date }}
              </span>
            </div>

            <div class="form-group">
              <label>Référence (optionnelle)</label>
              <div class="input-with-icon">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                </svg>
                <input type="text" v-model="form.reference" placeholder="Ex: PO-2025-0001" />
              </div>
            </div>

            <div class="form-group full-width">
              <label>Remarques</label>
              <div class="textarea-wrapper">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
                <textarea v-model="form.notes" rows="3"
                  placeholder="Notes additionnelles pour cette commande..."></textarea>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="right-column">
        <div class="card summary-card sticky-card">
          <div class="summary-header">
            <div class="summary-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M9 11l3 3L22 4"></path>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
              </svg>
            </div>
            <h3>Résumé</h3>
          </div>

          <div class="summary-content">
            <div class="summary-item">
              <div class="summary-label">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                  <line x1="7" y1="7" x2="7.01" y2="7"></line>
                </svg>
                Nombre d'articles
              </div>
              <div class="summary-value">{{ items.length }}</div>
            </div>

            <div class="summary-divider"></div>

            <div class="summary-item">
              <div class="summary-label">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="9" cy="21" r="1"></circle>
                  <circle cx="20" cy="21" r="1"></circle>
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                </svg>
                Total prix d'achat
              </div>
              <div class="summary-value highlight">{{ formatCurrency(totalPurchase) }}</div>
            </div>

            <div class="summary-item">
              <div class="summary-label">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <line x1="12" y1="1" x2="12" y2="23"></line>
                  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                </svg>
                Total prix public
              </div>
              <div class="summary-value">{{ formatCurrency(totalPublic) }}</div>
            </div>

            <div class="summary-divider"></div>

            <div class="summary-item margin-item">
              <div class="summary-label">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                </svg>
                Marge estimée
              </div>
              <div class="summary-value success">{{ formatCurrency(estimatedMargin) }}</div>
            </div>

            <div v-if="items.length > 0" class="summary-item margin-percent">
              <div class="margin-badge" :class="marginClass">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                  <polyline points="17 6 23 6 23 12"></polyline>
                </svg>
                {{ marginPercent }}%
              </div>
            </div>
          </div>

          <div class="summary-actions">
            <button class="summary-save-btn" :disabled="isSubmitting || items.length === 0" @click="handleSubmit">
              <span v-if="isSubmitting" class="spinner-small"></span>
              <template v-else>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                Enregistrer la commande
              </template>
            </button>
          </div>
        </div>

      </div>
    </div>
    <br>
    <div class="card products-card">
      <div class="card-header">
        <!-- <div class="card-icon products-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
            <line x1="7" y1="7" x2="7.01" y2="7"></line>
          </svg>
        </div> -->
        <div class="card-title-group">
          <h2 class="card-title">Articles de la commande</h2>
          <p class="card-subtitle">{{ items.length }} article{{ items.length > 1 ? 's' : '' }}</p>
        </div>
      </div>

      <div class="search-toolbar">
        <div class="search-box">
          <svg class="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          <input type="text" v-model="globalSearch" placeholder="Rechercher et ajouter un produit rapidement..."
            @input="onGlobalSearch" />
          <div v-if="globalSuggestions.length > 0" class="quick-add-badge">
            {{ globalSuggestions.length }} trouvé{{ globalSuggestions.length > 1 ? 's' : '' }}
          </div>
        </div>
        <button class="add-quick-btn" @click="addLineFromGlobal" :disabled="!canAddFromGlobal">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          Ajouter
        </button>
        <input type="file" ref="csvFileInput" accept=".csv" style="display: none" @change="handleCsvFileChange" />
        <button class="import-csv-btn" @click="triggerCsvImport" :disabled="isImporting">
          <span v-if="isImporting" class="spinner-small"></span>
          <template v-else>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="17 8 12 3 7 8"></polyline>
              <line x1="12" y1="3" x2="12" y2="15"></line>
            </svg>
            Importer CSV
          </template>
        </button>
      </div>

      <div v-if="items.length === 0" class="empty-state">
        <div class="empty-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="9" cy="21" r="1"></circle>
            <circle cx="20" cy="21" r="1"></circle>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
          </svg>
        </div>
        <h3>Aucun article ajouté</h3>
        <p>Commencez par rechercher et ajouter des produits à votre commande</p>
        <button class="add-first-line-btn" @click="addEmptyLine">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          Ajouter le premier article
        </button>
      </div>

      <div v-else class="table-container">
        <div class="table-wrapper" style="min-height: 500px;">
          <table class="products-table">
            <thead>
              <tr>
                <th class="col-product">Produit</th>
                <th class="col-number">Quantité</th>
                <th class="col-number">Prix achat</th>
                <th class="col-number">Prix public</th>
                <th class="col-number">Remise</th>
                <th class="col-total">Total</th>
                <th class="col-action"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(line, index) in items" :key="index" class="product-row">
                <td class="col-product">
                  <div class="product-cell">
                    <div class="product-search-wrapper">
                      <svg class="search-icon-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                      </svg>
                      <input type="text" v-model="line.search"
                        :placeholder="line.product ? line.product.name : 'Rechercher...'" @input="searchProducts(index)"
                        @focus="line.showDropdown = true" class="product-input" />
                    </div>
                    <transition name="dropdown">
                      <div v-if="line.showDropdown && line.suggestions.length" class="product-dropdown">
                        <div v-for="p in line.suggestions" :key="p.id" class="product-option"
                          @click="selectProduct(index, p)">
                          <div class="product-option-content">
                            <div class="product-name">{{ p.name }}</div>
                            <div class="product-meta">
                              <span class="product-id">#{{ p.id }}</span>
                              <span v-if="p.reference" class="product-ref">Réf: {{ p.reference }}</span>
                            </div>
                          </div>
                          <div class="product-prices">
                            <span v-if="p.price_excl_tax" class="price-tag">{{ formatCurrency(p.price_excl_tax)
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </td>
                <td class="col-number">
                  <div class="number-input-wrapper">
                    <input type="number" min="1" step="1" v-model.number="line.quantity"
                      @input="normalizeNumber(line, 'quantity', 2)" class="number-input" />
                  </div>
                </td>
                <td class="col-number">
                  <div class="currency-input-wrapper">
                    <input type="number" min="0" step="1" v-model.number="line.purchase_price"
                      @input="normalizeNumber(line, 'purchase_price', 0)" class="number-input" />
                    <span class="currency-label">FCFA</span>
                  </div>
                </td>
                <td class="col-number">
                  <div class="currency-input-wrapper">
                    <input type="number" min="0" step="1" v-model.number="line.sale_price"
                      @input="normalizeNumber(line, 'sale_price', 0)" class="number-input" />
                    <span class="currency-label">FCFA</span>
                  </div>
                </td>
                <td class="col-number">
                  <div class="currency-input-wrapper">
                    <input type="number" min="0" step="1" v-model.number="line.discount"
                      @input="normalizeNumber(line, 'discount', 0)" class="number-input" />
                    <span class="currency-label">FCFA</span>
                  </div>
                </td>
                <td class="col-total">
                  <div class="total-value">{{ formatCurrency(calculateLineTotal(line)) }}</div>
                </td>
                <td class="col-action">
                  <button class="delete-btn" @click="confirmRemoveLine(index)" title="Supprimer">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2">
                      </path>
                    </svg>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="add-line-section">
          <button class="add-line-btn" @click="addEmptyLine">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            Ajouter une ligne
          </button>
        </div>
      </div>
    </div>

    <transition name="modal">
      <div v-if="showCancelModal" class="modal-overlay" @click="showCancelModal = false">
        <div class="modal-content" @click.stop>
          <div class="modal-header warning">
            <div class="modal-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z">
                </path>
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
            </div>
            <h3>Annuler la commande ?</h3>
          </div>
          <div class="modal-body">
            <p>Toutes les informations saisies seront perdues. Cette action est irréversible.</p>
          </div>
          <div class="modal-actions">
            <button class="modal-btn secondary" @click="showCancelModal = false">
              Continuer l'édition
            </button>
            <button class="modal-btn danger" @click="confirmCancel">
              Oui, annuler
            </button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="modal">
      <div v-if="showDeleteModal" class="modal-overlay" @click="showDeleteModal = false">
        <div class="modal-content" @click.stop>
          <div class="modal-header danger">
            <div class="modal-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
            <h3>Supprimer cet article ?</h3>
          </div>
          <div class="modal-body">
            <p>Voulez-vous vraiment supprimer cet article de la commande ?</p>
          </div>
          <div class="modal-actions">
            <button class="modal-btn secondary" @click="showDeleteModal = false">
              Annuler
            </button>
            <button class="modal-btn danger" @click="confirmDelete">
              Supprimer
            </button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="modal">
      <div v-if="showSubmitModal" class="modal-overlay" @click="showSubmitModal = false">
        <div class="modal-content" @click.stop>
          <div class="modal-header success">
            <div class="modal-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
            <h3>Enregistrer cette commande ?</h3>
          </div>
          <div class="modal-body">
            <div class="modal-summary">
              <div class="modal-summary-item">
                <span class="label">Fournisseur:</span>
                <span class="value">{{ supplierSearch }}</span>
              </div>
              <div class="modal-summary-item">
                <span class="label">Articles:</span>
                <span class="value">{{ items.length }}</span>
              </div>
              <div class="modal-summary-item">
                <span class="label">Total achat:</span>
                <span class="value highlight">{{ formatCurrency(totalPurchase) }}</span>
              </div>
            </div>
          </div>
          <div class="modal-actions">
            <button class="modal-btn secondary" @click="showSubmitModal = false">
              Annuler
            </button>
            <button class="modal-btn primary" @click="confirmSubmit" :disabled="isSubmitting">
              <span v-if="isSubmitting" class="spinner-small"></span>
              <span v-else>Confirmer</span>
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal Import CSV - Produits non trouvés -->
    <transition name="modal">
      <div v-if="showImportModal" class="modal-overlay" @click.self="closeImportModal">
        <div class="modal-content import-modal" @click.stop>
          <div class="modal-header info">
            <div class="modal-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
            </div>
            <div class="modal-header-content">
              <h3>Produits à compléter</h3>
              <p class="modal-subtitle">{{ importNotFoundProducts.length }} produit{{ importNotFoundProducts.length > 1 ? 's' : '' }} non trouvé{{ importNotFoundProducts.length > 1 ? 's' : '' }} dans votre catalogue</p>
            </div>
            <button class="modal-close-btn" @click="closeImportModal">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <div class="modal-body import-modal-body">
            <div class="import-info-banner">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
              </svg>
              <span>Ces produits seront créés comme nouveaux articles. Veuillez sélectionner une catégorie pour chacun.</span>
            </div>
            <div class="import-products-list">
              <div v-for="(product, index) in importNotFoundProducts" :key="index" class="import-product-card">
                <div class="import-product-header">
                  <span class="import-product-number">#{{ index + 1 }}</span>
                  <button class="import-remove-btn" @click="removeImportProduct(index)" title="Supprimer">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                </div>
                <div class="import-product-grid">
                  <div class="import-field">
                    <label>Nom <span class="required">*</span></label>
                    <input type="text" v-model="product.name" placeholder="Nom du produit" />
                  </div>
                  <div class="import-field">
                    <label>Référence</label>
                    <input type="text" v-model="product.reference" placeholder="Référence (optionnel)" />
                  </div>
                  <div class="import-field">
                    <label>Catégorie <span class="required">*</span></label>
                    <div class="category-search-container">
                      <div class="category-search-input-wrapper">
                        <svg class="input-icon-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <circle cx="11" cy="11" r="8"></circle>
                          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                        </svg>
                        <input
                          type="text"
                          v-model="product.categorySearch"
                          placeholder="Rechercher une catégorie..."
                          @input="searchCategoriesForProduct(index)"
                          @focus="product.showCategoryDropdown = true"
                        />
                        <button v-if="product.category_id" class="clear-category-btn" @click="clearProductCategory(index)">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                          </svg>
                        </button>
                      </div>
                      <transition name="dropdown">
                        <div v-if="product.showCategoryDropdown && product.categorySuggestions.length > 0" class="category-dropdown">
                          <div
                            v-for="cat in product.categorySuggestions"
                            :key="cat.id"
                            class="category-option"
                            :class="{ selected: product.category_id === cat.id }"
                            @click="selectCategoryForProduct(index, cat)"
                          >
                            <span class="category-name">{{ cat.name }}</span>
                            <svg v-if="product.category_id === cat.id" class="check-icon-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                          </div>
                        </div>
                      </transition>
                    </div>
                    <span v-if="!product.category_id && product.showError" class="field-error-sm">
                      Catégorie requise
                    </span>
                  </div>
                  <div class="import-field">
                    <label>Quantité</label>
                    <input type="number" v-model.number="product.quantity" min="1" placeholder="1" />
                  </div>
                  <div class="import-field">
                    <label>Prix d'achat</label>
                    <div class="currency-input-sm">
                      <input type="number" v-model.number="product.purchase_price" min="0" placeholder="0" />
                      <span class="currency-suffix">FCFA</span>
                    </div>
                  </div>
                  <div class="import-field">
                    <label>Prix de vente</label>
                    <div class="currency-input-sm">
                      <input type="number" v-model.number="product.sale_price" min="0" placeholder="0" />
                      <span class="currency-suffix">FCFA</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-actions import-modal-actions">
            <button class="modal-btn secondary" @click="closeImportModal">
              Annuler
            </button>
            <button class="modal-btn primary" @click="confirmImportProducts" :disabled="importNotFoundProducts.length === 0">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              Ajouter {{ importNotFoundProducts.length }} produit{{ importNotFoundProducts.length > 1 ? 's' : '' }}
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import { productsService } from '@/services'
import supplierService from '@/services/supplierService'
import purchaseOrderService from '@/services/purchaseOrderService'
import categoriesService from '@/services/categoriesService'
import { useToastStore } from '@/store/modules/toastStore'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'CreatePurchaseOrderView',
  setup() {
    const router = useRouter()
    const toastStore = useToastStore()

    const suppliers = ref([])
    const supplierSearch = ref('')
    const supplierSuggestions = ref([])
    const showSupplierDropdown = ref(false)
    const supplierInput = ref(null)
    const isSubmitting = ref(false)
    const errors = ref({})
    const form = ref({
      supplier_id: '',
      order_date: new Date().toISOString().slice(0, 10),
      reference: '',
      notes: ''
    })

    const items = ref([])
    const globalSearch = ref('')
    const globalSuggestions = ref([])
    const globalSearchTimer = ref(null)

    const showCancelModal = ref(false)
    const showDeleteModal = ref(false)
    const showSubmitModal = ref(false)
    const lineToDelete = ref(null)

    // CSV Import
    const csvFileInput = ref(null)
    const isImporting = ref(false)
    const showImportModal = ref(false)
    const importNotFoundProducts = ref([])
    const categories = ref([])
    const csvParsedData = ref([])

    const canAddFromGlobal = computed(() => globalSuggestions.value.length > 0)

    const totalPurchase = computed(() => {
      return items.value.reduce((sum, l) => {
        const qty = Number(l.quantity) || 0
        const price = Number(l.purchase_price) || 0
        const discount = Number(l.discount) || 0
        return sum + Math.max(0, qty * price - discount)
      }, 0)
    })

    const totalPublic = computed(() => {
      return items.value.reduce((sum, l) => {
        const qty = Number(l.quantity) || 0
        const price = Number(l.sale_price) || 0
        return sum + qty * price
      }, 0)
    })

    const estimatedMargin = computed(() => {
      return totalPublic.value - totalPurchase.value
    })

    const marginPercent = computed(() => {
      if (totalPublic.value === 0) return 0
      return ((estimatedMargin.value / totalPublic.value) * 100).toFixed(1)
    })

    const marginClass = computed(() => {
      const margin = parseFloat(marginPercent.value)
      if (margin >= 30) return 'high'
      if (margin >= 15) return 'medium'
      return 'low'
    })

    const calculateLineTotal = (line) => {
      const qty = Number(line.quantity) || 0
      const price = Number(line.purchase_price) || 0
      const discount = Number(line.discount) || 0
      return Math.max(0, qty * price - discount)
    }

    const loadSuppliers = async () => {
      try {
        const res = await supplierService.getSuppliers({ per_page: 100, active_only: true })
        const data = res.data
        suppliers.value = Array.isArray(data) ? data : (data.data || data.items || [])
        supplierSuggestions.value = suppliers.value
      } catch (e) {
        suppliers.value = []
        supplierSuggestions.value = []
      }
    }

    const loadCategories = async () => {
      try {
        const res = await categoriesService.getCategories({ per_page: 100 })
        const data = res.data
        categories.value = Array.isArray(data) ? data : (data.data || data.items || [])
      } catch (e) {
        categories.value = []
      }
    }

    // CSV Import Functions
    const triggerCsvImport = () => {
      if (csvFileInput.value) {
        csvFileInput.value.click()
      }
    }

    const handleCsvFileChange = async (event) => {
      const file = event.target.files[0]
      if (!file) return

      // Reset file input
      event.target.value = ''

      if (!file.name.endsWith('.csv')) {
        toastStore.addToast({
          type: 'error',
          message: 'Veuillez sélectionner un fichier CSV',
          duration: 3000
        })
        return
      }

      isImporting.value = true

      try {
        const csvContent = await readFileAsText(file)
        const parsedData = parseCsv(csvContent)

        if (parsedData.length === 0) {
          toastStore.addToast({
            type: 'error',
            message: 'Le fichier CSV est vide ou mal formaté',
            duration: 3000
          })
          return
        }

        csvParsedData.value = parsedData
        await processImport(parsedData)
      } catch (error) {
        toastStore.addToast({
          type: 'error',
          message: error.message || 'Erreur lors de la lecture du fichier CSV',
          duration: 4000
        })
      } finally {
        isImporting.value = false
      }
    }

    const readFileAsText = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => resolve(e.target.result)
        reader.onerror = () => reject(new Error('Erreur de lecture du fichier'))
        reader.readAsText(file)
      })
    }

    const parseCsv = (content) => {
      const lines = content.split('\n').map(line => line.trim()).filter(line => line)
      if (lines.length < 2) return []

      // Parse header
      const header = lines[0].split(/[,;]/).map(h => h.trim().toLowerCase())

      // Find column indices
      const refIndex = header.findIndex(h => h === 'reference' || h === 'ref' || h === 'référence')
      const nameIndex = header.findIndex(h => h === 'nom' || h === 'name' || h === 'produit' || h === 'designation' || h === 'désignation')
      const purchasePriceIndex = header.findIndex(h => h === 'prix_achat' || h === 'prix achat' || h === 'purchase_price' || h === 'pa')
      const salePriceIndex = header.findIndex(h => h === 'prix_vente' || h === 'prix vente' || h === 'sale_price' || h === 'pv')
      const quantityIndex = header.findIndex(h => h === 'quantite' || h === 'quantité' || h === 'quantity' || h === 'qte' || h === 'qty')

      if (nameIndex === -1) {
        throw new Error('La colonne "nom" est requise dans le fichier CSV')
      }

      const result = []
      for (let i = 1; i < lines.length; i++) {
        const values = lines[i].split(/[,;]/).map(v => v.trim())

        const name = values[nameIndex] || ''
        if (!name) continue

        result.push({
          reference: refIndex !== -1 ? (values[refIndex] || null) : null,
          name: name,
          purchase_price: purchasePriceIndex !== -1 ? (parseFloat(values[purchasePriceIndex]) || null) : null,
          sale_price: salePriceIndex !== -1 ? (parseFloat(values[salePriceIndex]) || null) : null,
          quantity: quantityIndex !== -1 ? (parseInt(values[quantityIndex]) || 1) : 1
        })
      }

      return result
    }

    const processImport = async (parsedData) => {
      // Prepare references and names for API call
      const references = parsedData.filter(p => p.reference).map(p => p.reference)
      const names = parsedData.map(p => p.name)

      try {
        const response = await productsService.importProductsFromReferences({
          references: references.length > 0 ? references : undefined,
          names: names,
          with: ['category']
        })

        const data = response.data
        const foundProducts = data.products || []
        const summary = data.summary || {}

        // Add found products to items
        let addedCount = 0
        for (const product of foundProducts) {
          // Find the corresponding CSV data
          const csvItem = parsedData.find(p =>
            (p.reference && p.reference === product.reference) ||
            p.name.toLowerCase() === product.name.toLowerCase()
          )

          if (csvItem) {
            // Check if product already exists in items
            const existingIndex = items.value.findIndex(l => l.product_id === product.id)
            if (existingIndex !== -1) {
              // Update quantity
              items.value[existingIndex].quantity += csvItem.quantity
            } else {
              // Remove empty lines first
              const emptyLineIndex = items.value.findIndex(l => !l.product_id)
              if (emptyLineIndex !== -1) {
                items.value.splice(emptyLineIndex, 1)
              }

              // Add new line
              items.value.push({
                product: product,
                product_id: product.id,
                search: product.name,
                suggestions: [],
                showDropdown: false,
                quantity: csvItem.quantity,
                purchase_price: csvItem.purchase_price || product.price_excl_tax || 0,
                sale_price: csvItem.sale_price || product.price_incl_tax || 0,
                discount: 0
              })
              addedCount++
            }
          }
        }

        // Prepare not found products for modal
        const notFoundRefs = summary.not_found_references || []
        const notFoundNames = summary.not_found_names || []

        const notFoundItems = parsedData.filter(p => {
          if (p.reference && notFoundRefs.includes(p.reference)) return true
          if (notFoundNames.includes(p.name)) return true
          return false
        })

        if (notFoundItems.length > 0) {
          // Load categories if not loaded
          if (categories.value.length === 0) {
            await loadCategories()
          }

          importNotFoundProducts.value = notFoundItems.map(item => ({
            name: item.name,
            reference: item.reference || '',
            category_id: null,
            categorySearch: '',
            categorySuggestions: [...categories.value],
            showCategoryDropdown: false,
            showError: false,
            quantity: item.quantity || 1,
            purchase_price: item.purchase_price || 0,
            sale_price: item.sale_price || 0
          }))

          showImportModal.value = true
        }

        if (addedCount > 0) {
          toastStore.addToast({
            type: 'success',
            message: `${addedCount} produit${addedCount > 1 ? 's' : ''} ajouté${addedCount > 1 ? 's' : ''} à la commande`,
            duration: 3000
          })
        }

        if (notFoundItems.length > 0 && addedCount > 0) {
          toastStore.addToast({
            type: 'info',
            message: `${notFoundItems.length} produit${notFoundItems.length > 1 ? 's' : ''} nécessite${notFoundItems.length > 1 ? 'nt' : ''} votre attention`,
            duration: 3000
          })
        }

      } catch (error) {
        toastStore.addToast({
          type: 'error',
          message: error?.response?.data?.message || 'Erreur lors de l\'import des produits',
          duration: 4000
        })
      }
    }

    const searchCategoriesForProduct = (index) => {
      const product = importNotFoundProducts.value[index]
      if (!product) return

      const query = (product.categorySearch || '').trim().toLowerCase()
      if (!query) {
        product.categorySuggestions = [...categories.value]
      } else {
        product.categorySuggestions = categories.value.filter(cat =>
          cat.name.toLowerCase().includes(query)
        )
      }
      product.showCategoryDropdown = true
    }

    const selectCategoryForProduct = (index, category) => {
      const product = importNotFoundProducts.value[index]
      if (!product) return

      product.category_id = category.id
      product.categorySearch = category.name
      product.showCategoryDropdown = false
      product.showError = false
    }

    const clearProductCategory = (index) => {
      const product = importNotFoundProducts.value[index]
      if (!product) return

      product.category_id = null
      product.categorySearch = ''
      product.categorySuggestions = [...categories.value]
    }

    const removeImportProduct = (index) => {
      importNotFoundProducts.value.splice(index, 1)
      if (importNotFoundProducts.value.length === 0) {
        showImportModal.value = false
      }
    }

    const closeImportModal = () => {
      showImportModal.value = false
      importNotFoundProducts.value = []
    }

    const confirmImportProducts = () => {
      // Validate all products have categories
      let hasErrors = false
      for (const product of importNotFoundProducts.value) {
        if (!product.category_id) {
          product.showError = true
          hasErrors = true
        }
      }

      if (hasErrors) {
        toastStore.addToast({
          type: 'error',
          message: 'Veuillez sélectionner une catégorie pour tous les produits',
          duration: 3000
        })
        return
      }

      // Remove empty lines first
      const emptyLineIndex = items.value.findIndex(l => !l.product_id)
      if (emptyLineIndex !== -1) {
        items.value.splice(emptyLineIndex, 1)
      }

      // Add products as new items (they will be created when submitting the order)
      for (const product of importNotFoundProducts.value) {
        items.value.push({
          product: null,
          product_id: null,
          isNewProduct: true,
          newProductData: {
            name: product.name,
            reference: product.reference || null,
            category_id: product.category_id,
            price_excl_tax: product.purchase_price,
            price_incl_tax: product.sale_price
          },
          search: product.name,
          suggestions: [],
          showDropdown: false,
          quantity: product.quantity || 1,
          purchase_price: product.purchase_price || 0,
          sale_price: product.sale_price || 0,
          discount: 0
        })
      }

      toastStore.addToast({
        type: 'success',
        message: `${importNotFoundProducts.value.length} nouveau${importNotFoundProducts.value.length > 1 ? 'x' : ''} produit${importNotFoundProducts.value.length > 1 ? 's' : ''} ajouté${importNotFoundProducts.value.length > 1 ? 's' : ''}`,
        duration: 3000
      })

      closeImportModal()
      addEmptyLine()
    }

    const addEmptyLine = () => {
      items.value.push({
        product: null,
        product_id: null,
        search: '',
        suggestions: [],
        showDropdown: false,
        quantity: 1,
        purchase_price: 0,
        sale_price: 0,
        discount: 0
      })
    }

    const removeLine = (index) => {
      items.value.splice(index, 1)
    }

    const confirmRemoveLine = (index) => {
      lineToDelete.value = index
      showDeleteModal.value = true
    }

    const confirmDelete = () => {
      if (lineToDelete.value !== null) {
        removeLine(lineToDelete.value)
        lineToDelete.value = null
      }
      showDeleteModal.value = false
    }

    const scrollToLine = (index) => {
      setTimeout(() => {
        const rows = document.querySelectorAll('.product-row')
        if (rows && rows[index]) {
          rows[index].scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      }, 0)
    }

    const searchProducts = (index) => {
      const line = items.value[index]
      if (!line) return
      const q = (line.search || '').trim()
      if (!q) {
        line.suggestions = []
        return
      }
      productsService.getProducts({
        search: q,
        per_page: 10
      }).then(res => {
        const data = res.data
        line.suggestions = Array.isArray(data) ? data : (data.data || [])
      }).catch(() => {
        line.suggestions = []
      }).finally(() => {
        line.showDropdown = true
      })
    }

    const selectProduct = (index, product) => {
      const line = items.value[index]
      if (!line) return
      const duplicateIndex = items.value.findIndex((l, i) => l.product_id === product.id && i !== index)
      if (duplicateIndex !== -1) {
        toastStore.addToast({
          type: 'warning',
          message: 'Ce produit est déjà ajouté dans la commande',
          duration: 3000
        })
        line.showDropdown = false
        line.suggestions = []
        line.search = ''
        scrollToLine(duplicateIndex)
        return
      }
      line.product = product
      line.product_id = product.id
      line.search = product.name
      line.showDropdown = false
      line.suggestions = []
      if (product.price_excl_tax !== undefined && product.price_excl_tax !== null) {
        line.purchase_price = Number(product.price_excl_tax)
      }
      if (product.price_incl_tax !== undefined && product.price_incl_tax !== null) {
        line.sale_price = Number(product.price_incl_tax)
      }
      addEmptyLine()
    }

    const onGlobalSearch = () => {
      if (globalSearchTimer.value) clearTimeout(globalSearchTimer.value)
      const q = (globalSearch.value || '').trim()
      if (!q) {
        globalSuggestions.value = []
        return
      }
      globalSearchTimer.value = setTimeout(() => {
        productsService.getProducts({ search: q, per_page: 10 })
          .then(res => {
            const data = res.data
            globalSuggestions.value = Array.isArray(data) ? data : (data.data || [])
          })
          .catch(() => { globalSuggestions.value = [] })
      }, 300)
    }

    const addLineFromGlobal = () => {
      if (!globalSuggestions.value.length) return
      const product = globalSuggestions.value[0]
      const existingIndex = items.value.findIndex(l => l.product_id === product.id)
      if (existingIndex !== -1) {
        toastStore.addToast({
          type: 'warning',
          message: 'Ce produit est déjà présent dans la commande',
          duration: 3000
        })
        scrollToLine(existingIndex)
        globalSearch.value = ''
        globalSuggestions.value = []
        return
      }
      addEmptyLine()
      selectProduct(items.value.length - 1, product)
      globalSearch.value = ''
      globalSuggestions.value = []
    }

    const searchSuppliers = () => {
      const query = (supplierSearch.value || '').trim()
      if (!query) {
        supplierSuggestions.value = suppliers.value
        return
      }
      supplierService.getSuppliers({
        search: query,
        per_page: 10,
        active_only: true
      }).then(res => {
        const data = res.data
        supplierSuggestions.value = Array.isArray(data) ? data : (data.data || [])
      }).catch(() => {
        supplierSuggestions.value = []
      })
    }

    const selectSupplier = (s) => {
      form.value.supplier_id = s.id
      supplierSearch.value = s.name
      showSupplierDropdown.value = false
    }

    const clearSupplierSelection = () => {
      form.value.supplier_id = ''
      supplierSearch.value = ''
      supplierSuggestions.value = suppliers.value
      showSupplierDropdown.value = false
      if (supplierInput.value) supplierInput.value.focus()
    }

    const normalizeNumber = (line, key, decimals) => {
      let val = Number(line[key])
      if (!isFinite(val) || val < 0) val = 0
      const factor = Math.pow(10, decimals)
      line[key] = Math.round(val * factor) / factor
    }

    const validate = () => {
      const e = {}
      if (!form.value.supplier_id) e.supplier_id = 'Le fournisseur est requis'
      if (!form.value.order_date) e.order_date = 'La date est requise'

      // Filter out empty lines (lines without product and without newProductData)
      const validItems = items.value.filter(l => l.product_id || l.isNewProduct)

      if (validItems.length === 0) {
        toastStore.addToast({ type: 'error', message: 'Ajoutez au moins une ligne', duration: 3000 })
        errors.value = e
        return false
      }

      let validLines = true
      for (const l of validItems) {
        // Check if it's a valid existing product or a valid new product
        const hasValidProduct = l.product_id || (l.isNewProduct && l.newProductData && l.newProductData.name && l.newProductData.category_id)
        if (!hasValidProduct || (Number(l.quantity) || 0) <= 0 || (Number(l.purchase_price) || 0) < 0) {
          validLines = false
          break
        }
      }
      if (!validLines) {
        toastStore.addToast({ type: 'error', message: 'Vérifiez les lignes (produit, quantité, prix)', duration: 3500 })
      }
      // Contrôle des doublons produits (only for existing products)
      const productIds = validItems.map(l => l.product_id).filter(Boolean)
      const hasDuplicates = new Set(productIds).size !== productIds.length
      if (hasDuplicates) {
        toastStore.addToast({ type: 'error', message: 'Vous avez des doublons de produits dans la commande', duration: 3500 })
      }
      errors.value = e
      return Object.keys(e).length === 0 && validLines && !hasDuplicates
    }

    const handleCancel = () => {
      if (items.value.length > 0 || form.value.supplier_id) {
        showCancelModal.value = true
      } else {
        router.push({ name: 'purchase-orders' })
      }
    }

    const confirmCancel = () => {
      showCancelModal.value = false
      router.push({ name: 'purchase-orders' })
    }

    const handleSubmit = () => {
      if (!validate()) return
      showSubmitModal.value = true
    }

    const confirmSubmit = async () => {
      if (isSubmitting.value) return
      isSubmitting.value = true
      try {
        // Filter out empty lines
        const validItems = items.value.filter(l => l.product_id || l.isNewProduct)

        const payload = {
          supplier_id: form.value.supplier_id,
          order_date: form.value.order_date,
          notes: form.value.notes || null,
          reference: form.value.reference || null,
          items: validItems.map(l => {
            if (l.isNewProduct && l.newProductData) {
              // New product to create
              return {
                is_new_product: true,
                new_product_data: {
                  name: l.newProductData.name,
                  reference: l.newProductData.reference || null,
                  category_id: l.newProductData.category_id,
                  price_excl_tax: Number(l.purchase_price) || 0,
                  price_incl_tax: Number(l.sale_price) || 0
                },
                quantity: Number(l.quantity),
                purchase_price: Number(l.purchase_price),
                sale_price: l.sale_price !== null && l.sale_price !== '' ? Number(l.sale_price) : null,
                discount: l.discount ? Number(l.discount) : 0
              }
            } else {
              // Existing product
              return {
                product_id: l.product_id,
                quantity: Number(l.quantity),
                purchase_price: Number(l.purchase_price),
                sale_price: l.sale_price !== null && l.sale_price !== '' ? Number(l.sale_price) : null,
                discount: l.discount ? Number(l.discount) : 0
              }
            }
          })
        }
        await purchaseOrderService.createPurchaseOrder(payload)
        toastStore.addToast({ type: 'success', message: 'Commande créée avec succès', duration: 4000 })
        showSubmitModal.value = false
        router.push({ name: 'purchase-orders' })
      } catch (err) {
        toastStore.addToast({
          type: 'error',
          message: err?.message || 'Erreur lors de la création de la commande',
          duration: 4000
        })
      } finally {
        isSubmitting.value = false
      }
    }

    loadSuppliers()
    addEmptyLine()

    const formatCurrency = (amount) => {
      return new Intl.NumberFormat('fr-FR', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount || 0) + ' FCFA'
    }

    return {
      suppliers,
      form,
      errors,
      isSubmitting,
      items,
      globalSearch,
      globalSuggestions,
      canAddFromGlobal,
      addLineFromGlobal,
      onGlobalSearch,
      addEmptyLine,
      removeLine,
      confirmRemoveLine,
      searchProducts,
      selectProduct,
      supplierInput,
      supplierSearch,
      supplierSuggestions,
      showSupplierDropdown,
      searchSuppliers,
      selectSupplier,
      clearSupplierSelection,
      normalizeNumber,
      totalPurchase,
      totalPublic,
      estimatedMargin,
      marginPercent,
      marginClass,
      calculateLineTotal,
      handleCancel,
      confirmCancel,
      handleSubmit,
      confirmSubmit,
      confirmDelete,
      formatCurrency,
      showCancelModal,
      showDeleteModal,
      showSubmitModal,
      scrollToLine,
      // CSV Import
      csvFileInput,
      isImporting,
      showImportModal,
      importNotFoundProducts,
      triggerCsvImport,
      handleCsvFileChange,
      searchCategoriesForProduct,
      selectCategoryForProduct,
      clearProductCategory,
      removeImportProduct,
      closeImportModal,
      confirmImportProducts
    }
  }
})
</script>

<style scoped>
.create-po-view {
  padding: 0 0 24px 0;
  max-width: 1600px;
  margin: 0 auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.back-btn {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 1.5px solid #e2e8f0;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.back-btn:hover {
  background: #f8fafc;
  border-color: #0A5C6B;
}

.back-btn svg {
  width: 20px;
  height: 20px;
  stroke: #475569;
  stroke-width: 2;
}

.header-info {
  flex: 1;
}

.page-heading {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 4px 0;
  letter-spacing: -0.5px;
}

.page-subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

.actions {
  display: flex;
  gap: 8px;
}

.primary-btn,
.secondary-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.2s;
}

.primary-btn svg,
.secondary-btn svg {
  width: 18px;
  height: 18px;
  stroke-width: 2;
}

.primary-btn {
  background: linear-gradient(135deg, #0A5C6B 0%, #0e7689 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(10, 92, 107, 0.2);
}

.primary-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(10, 92, 107, 0.3);
}

.primary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.secondary-btn {
  background: white;
  color: #475569;
  border: 1.5px solid #e2e8f0;
}

.secondary-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 380px;
  gap: 24px;
}

.left-column,
.right-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.progress-indicator {
  display: flex;
  align-items: center;
  background: white;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px 24px;
  gap: 12px;
}

.progress-step {
  display: flex;
  align-items: center;
  gap: 12px;
  opacity: 0.4;
  transition: opacity 0.3s;
}

.progress-step.active {
  opacity: 1;
}

.progress-step.completed {
  opacity: 1;
}

.step-number {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f1f5f9;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  transition: all 0.3s;
  flex-shrink: 0;
}

.progress-step.active .step-number {
  background: linear-gradient(135deg, #0A5C6B 0%, #0e7689 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(10, 92, 107, 0.3);
}

.progress-step.completed .step-number {
  background: #e8f5e9;
  color: #2e7d32;
}

.step-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.step-title {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}

.step-desc {
  font-size: 12px;
  color: #64748b;
}

.progress-line {
  flex: 1;
  height: 2px;
  background: #e2e8f0;
  transition: background 0.3s;
}

.progress-line.completed {
  background: linear-gradient(90deg, #0A5C6B 0%, #0e7689 100%);
}

.card {
  background: white;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  transition: all 0.3s;
}

.card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
}

.card-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f1f5f9;
}

.card-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.card-icon svg {
  width: 24px;
  height: 24px;
  stroke-width: 2;
}

.supplier-icon {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
}

.supplier-icon svg {
  stroke: #1976d2;
}

.products-icon {
  background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);
}

.products-icon svg {
  stroke: #7b1fa2;
}

.card-title-group {
  flex: 1;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 4px 0;
  letter-spacing: -0.3px;
}

.card-subtitle {
  font-size: 13px;
  color: #64748b;
  margin: 0;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  display: flex;
  align-items: center;
  gap: 4px;
}

.required {
  color: #dc2626;
  font-weight: 700;
}

.supplier-search-container {
  position: relative;
}

.supplier-search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.supplier-search-input-wrapper.has-value {
  border-color: #0A5C6B;
}

.input-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
  z-index: 1;
  width: 18px;
  height: 18px;
  stroke-width: 2;
}

.supplier-search-input {
  width: 100%;
  padding: 12px 44px 12px 40px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  background: white;
  transition: all 0.2s;
}

.supplier-search-input:focus {
  outline: none;
  border-color: #0A5C6B;
  box-shadow: 0 0 0 3px rgba(10, 92, 107, 0.1);
}

.clear-search-btn {
  position: absolute;
  right: 8px;
  background: #f1f5f9;
  border: none;
  cursor: pointer;
  color: #64748b;
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  z-index: 2;
}

.clear-search-btn:hover {
  background: #e2e8f0;
  color: #0f172a;
}

.clear-search-btn svg {
  width: 16px;
  height: 16px;
  stroke-width: 2;
}

.selected-indicator {
  position: absolute;
  right: 8px;
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  color: #2e7d32;
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.selected-indicator svg {
  width: 16px;
  height: 16px;
  stroke-width: 2.5;
}

.supplier-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background: white;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  max-height: 280px;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 100;
}

.supplier-option {
  padding: 12px 14px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.supplier-option:last-child {
  border-bottom: none;
}

.supplier-option:hover {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.supplier-option.selected {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
}

.supplier-option-content {
  flex: 1;
}

.supplier-name {
  font-weight: 600;
  color: #0f172a;
  font-size: 14px;
  margin-bottom: 4px;
}

.supplier-meta {
  font-size: 12px;
  color: #64748b;
  display: flex;
  gap: 12px;
  align-items: center;
}

.supplier-meta span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.supplier-meta svg {
  width: 12px;
  height: 12px;
  stroke-width: 2;
}

.check-icon {
  width: 18px;
  height: 18px;
  stroke: #0A5C6B;
  stroke-width: 2.5;
  flex-shrink: 0;
}

.no-suppliers-found {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background: white;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  padding: 20px;
  color: #64748b;
  font-size: 14px;
  z-index: 100;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.no-suppliers-found svg {
  width: 24px;
  height: 24px;
  stroke-width: 2;
  color: #94a3b8;
}

.no-suppliers-found p {
  margin: 0;
}

.input-with-icon {
  position: relative;
  display: flex;
  align-items: center;
}

.input-with-icon input {
  width: 100%;
  padding: 12px 12px 12px 40px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  transition: all 0.2s;
}

.input-with-icon input:focus {
  outline: none;
  border-color: #0A5C6B;
  box-shadow: 0 0 0 3px rgba(10, 92, 107, 0.1);
}

.textarea-wrapper {
  position: relative;
}

.textarea-wrapper .input-icon {
  position: absolute;
  left: 12px;
  top: 12px;
}

.textarea-wrapper textarea {
  width: 100%;
  padding: 12px 12px 12px 40px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: all 0.2s;
}

.textarea-wrapper textarea:focus {
  outline: none;
  border-color: #0A5C6B;
  box-shadow: 0 0 0 3px rgba(10, 92, 107, 0.1);
}

.field-error {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #dc2626;
  font-size: 12px;
  font-weight: 500;
}

.field-error svg {
  width: 14px;
  height: 14px;
  stroke-width: 2;
  flex-shrink: 0;
}

.search-toolbar {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.search-box {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 14px;
  transition: all 0.2s;
}

.search-box:focus-within {
  background: white;
  border-color: #0A5C6B;
  box-shadow: 0 0 0 3px rgba(10, 92, 107, 0.1);
}

.search-icon {
  width: 18px;
  height: 18px;
  stroke: #94a3b8;
  stroke-width: 2;
  flex-shrink: 0;
}

.search-box input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  padding: 12px 12px;
  font-size: 14px;
  color: #0f172a;
}

.quick-add-badge {
  background: linear-gradient(135deg, #0A5C6B 0%, #0e7689 100%);
  color: white;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.add-quick-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: linear-gradient(135deg, #0A5C6B 0%, #0e7689 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.add-quick-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(10, 92, 107, 0.3);
}

.add-quick-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.add-quick-btn svg {
  width: 18px;
  height: 18px;
  stroke-width: 2;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  gap: 16px;
}

.empty-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-icon svg {
  width: 40px;
  height: 40px;
  stroke: #94a3b8;
  stroke-width: 2;
}

.empty-state h3 {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.empty-state p {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  max-width: 400px;
}

.add-first-line-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #0A5C6B 0%, #0e7689 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 8px;
}

.add-first-line-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(10, 92, 107, 0.3);
}

.add-first-line-btn svg {
  width: 18px;
  height: 18px;
  stroke-width: 2;
}

.table-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.table-wrapper {
  overflow-x: auto;
  overflow-y: visible;
  border-radius: 10px;
  max-height: 400px;
  border: 1.5px solid #e2e8f0;
}

.products-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1000px;
}

.products-table thead {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.products-table th {
  padding: 14px 12px;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #e2e8f0;
}

.products-table td {
  padding: 12px;
  border-bottom: 1px solid #f1f5f9;
}

.product-row:hover {
  background: #fafbfc;
}

.product-row:last-child td {
  border-bottom: none;
}

.col-product {
  width: 200px;
}

.col-number {
  width: 120px;
}

.col-total {
  width: 140px;
}

.col-action {
  width: 60px;
  text-align: center;
}

.product-cell {
  position: relative;
}

.product-search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon-sm {
  position: absolute;
  left: 10px;
  width: 16px;
  height: 16px;
  stroke: #94a3b8;
  stroke-width: 2;
  z-index: 1;
}

.product-input {
  width: 100%;
  padding: 10px 10px 10px 34px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s;
}

.product-input:focus {
  outline: none;
  border-color: #0A5C6B;
  box-shadow: 0 0 0 3px rgba(10, 92, 107, 0.1);
}

.product-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background: white;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  max-height: 240px;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 1000;
}

.product-option {
  padding: 12px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.product-option:last-child {
  border-bottom: none;
}

.product-option:hover {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.product-option-content {
  flex: 1;
}

.product-name {
  font-weight: 600;
  color: #0f172a;
  font-size: 14px;
  margin-bottom: 4px;
}

.product-meta {
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: #64748b;
}

.product-id {
  font-weight: 600;
}

.product-prices {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.price-tag {
  font-size: 13px;
  font-weight: 700;
  color: #0A5C6B;
  background: #f0f9ff;
  padding: 4px 8px;
  border-radius: 6px;
}

.number-input-wrapper,
.currency-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.number-input {
  width: 100%;
  padding: 10px 12px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  text-align: right;
  transition: all 0.2s;
}

.currency-input-wrapper .number-input {
  padding-right: 50px;
}

.number-input:focus {
  outline: none;
  border-color: #0A5C6B;
  box-shadow: 0 0 0 3px rgba(10, 92, 107, 0.1);
}

.currency-label {
  position: absolute;
  right: 12px;
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
  pointer-events: none;
}

.total-value {
  font-size: 14px;
  font-weight: 700;
  color: #0A5C6B;
  text-align: right;
}

.delete-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1.5px solid #fee2e2;
  background: #fef2f2;
  color: #dc2626;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.delete-btn:hover {
  background: #fecaca;
  border-color: #fca5a5;
  transform: scale(1.05);
}

.delete-btn svg {
  width: 18px;
  height: 18px;
  stroke-width: 2;
}

.add-line-section {
  padding: 16px 0 0;
  border-top: 2px dashed #e2e8f0;
}

.add-line-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: transparent;
  color: #0A5C6B;
  border: 1.5px dashed #0A5C6B;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.add-line-btn:hover {
  background: #f0f9ff;
  border-style: solid;
}

.add-line-btn svg {
  width: 18px;
  height: 18px;
  stroke-width: 2;
}

.sticky-card {
  position: sticky;
  top: 20px;
}

.summary-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 2px solid #e2e8f0;
}

.summary-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e2e8f0;
}

.summary-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #0A5C6B 0%, #0e7689 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.summary-icon svg {
  width: 22px;
  height: 22px;
  stroke: white;
  stroke-width: 2;
}

.summary-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.summary-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: white;
  border-radius: 8px;
  gap: 12px;
}

.summary-item.margin-item {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  border: 1.5px solid #a5d6a7;
}

.summary-item.margin-percent {
  justify-content: center;
}

.summary-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #64748b;
  font-weight: 600;
}

.summary-label svg {
  width: 16px;
  height: 16px;
  stroke-width: 2;
  stroke: #94a3b8;
}

.summary-value {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.summary-value.highlight {
  font-size: 18px;
  color: #0A5C6B;
}

.summary-value.success {
  color: #2e7d32;
}

.summary-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
}

.margin-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
}

.margin-badge svg {
  width: 16px;
  height: 16px;
  stroke-width: 2.5;
}

.margin-badge.high {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  color: #2e7d32;
}

.margin-badge.medium {
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
  color: #e65100;
}

.margin-badge.low {
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
  color: #c62828;
}

.summary-actions {
  padding-top: 16px;
  border-top: 2px solid #e2e8f0;
}

.summary-save-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #0A5C6B 0%, #0e7689 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(10, 92, 107, 0.3);
}

.summary-save-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(10, 92, 107, 0.4);
}

.summary-save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.summary-save-btn svg {
  width: 20px;
  height: 20px;
  stroke-width: 2.5;
}

.help-card {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1.5px solid #bae6fd;
  padding: 20px;
}

.help-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.help-icon svg {
  width: 24px;
  height: 24px;
  stroke: #0284c7;
  stroke-width: 2;
}

.help-card h4 {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 8px 0;
}

.help-card p {
  font-size: 13px;
  color: #475569;
  margin: 0;
  line-height: 1.6;
}

.spinner-small {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 16px;
  max-width: 480px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalSlideUp 0.3s ease-out;
}

@keyframes modalSlideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  padding: 24px 24px 20px;
  text-align: center;
}

.modal-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}

.modal-header.warning .modal-icon {
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
}

.modal-header.warning .modal-icon svg {
  width: 32px;
  height: 32px;
  stroke: #e65100;
  stroke-width: 2;
}

.modal-header.danger .modal-icon {
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
}

.modal-header.danger .modal-icon svg {
  width: 32px;
  height: 32px;
  stroke: #c62828;
  stroke-width: 2;
}

.modal-header.success .modal-icon {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
}

.modal-header.success .modal-icon svg {
  width: 32px;
  height: 32px;
  stroke: #2e7d32;
  stroke-width: 2;
}

.modal-header h3 {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.modal-body {
  padding: 0 24px 24px;
}

.modal-body p {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  text-align: center;
  line-height: 1.6;
}

.modal-summary {
  background: #f8fafc;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.modal-summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}

.modal-summary-item .label {
  font-size: 13px;
  color: #64748b;
  font-weight: 600;
}

.modal-summary-item .value {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.modal-summary-item .value.highlight {
  color: #0A5C6B;
  font-size: 16px;
}

.modal-actions {
  display: flex;
  gap: 12px;
  padding: 0 24px 24px;
}

.modal-btn {
  flex: 1;
  padding: 12px 20px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.modal-btn.secondary {
  background: #f1f5f9;
  color: #475569;
}

.modal-btn.secondary:hover {
  background: #e2e8f0;
}

.modal-btn.primary {
  background: linear-gradient(135deg, #0A5C6B 0%, #0e7689 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.modal-btn.primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(10, 92, 107, 0.3);
}

.modal-btn.primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.modal-btn.danger {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: white;
}

.modal-btn.danger:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.2s;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 1280px) {
  .layout {
    grid-template-columns: 1fr 340px;
  }
}

@media (max-width: 1024px) {
  .layout {
    grid-template-columns: 1fr;
  }

  .sticky-card {
    position: static;
  }

  .progress-indicator {
    flex-wrap: wrap;
  }

  .progress-step {
    flex: 1;
    min-width: 140px;
  }

  .progress-line {
    display: none;
  }
}

@media (max-width: 768px) {
  .create-po-view {
    padding: 0 0 16px 0;
  }

  .page-header {
    flex-direction: column;
    align-items: stretch;
  }

  .header-left {
    flex-direction: column;
    align-items: stretch;
  }

  .back-btn {
    align-self: flex-start;
  }

  .actions {
    width: 100%;
  }

  .actions button {
    flex: 1;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .progress-indicator {
    flex-direction: column;
    gap: 16px;
  }

  .progress-step {
    width: 100%;
  }

  .table-wrapper {
    border-radius: 0;
    margin: 0 -24px;
  }

  .card {
    border-radius: 10px;
    padding: 16px;
  }

  .search-toolbar {
    flex-direction: column;
  }

  .search-box {
    width: 100%;
  }
}

/* CSV Import Button */
.import-csv-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.import-csv-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.import-csv-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.import-csv-btn svg {
  width: 18px;
  height: 18px;
  stroke-width: 2;
}

/* Import Modal */
.import-modal {
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-header.info {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 24px;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
}

.modal-header.info .modal-icon {
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  flex-shrink: 0;
}

.modal-header.info .modal-icon svg {
  width: 28px;
  height: 28px;
  stroke: #0284c7;
  stroke-width: 2;
}

.modal-header-content {
  flex: 1;
}

.modal-header-content h3 {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 4px 0;
}

.modal-subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

.modal-close-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
}

.modal-close-btn:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.modal-close-btn svg {
  width: 18px;
  height: 18px;
  stroke: #64748b;
  stroke-width: 2;
}

.import-modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px;
  max-height: 60vh;
}

.import-info-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border: 1px solid #fcd34d;
  border-radius: 10px;
  margin-bottom: 20px;
}

.import-info-banner svg {
  width: 20px;
  height: 20px;
  stroke: #b45309;
  stroke-width: 2;
  flex-shrink: 0;
}

.import-info-banner span {
  font-size: 13px;
  color: #92400e;
  font-weight: 500;
}

.import-products-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.import-product-card {
  background: #f8fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  transition: all 0.2s;
}

.import-product-card:hover {
  border-color: #cbd5e1;
}

.import-product-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.import-product-number {
  font-size: 13px;
  font-weight: 700;
  color: #0A5C6B;
  background: #e0f7fa;
  padding: 4px 10px;
  border-radius: 6px;
}

.import-remove-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #fee2e2;
  background: #fef2f2;
  color: #dc2626;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.import-remove-btn:hover {
  background: #fecaca;
  border-color: #fca5a5;
}

.import-remove-btn svg {
  width: 16px;
  height: 16px;
  stroke-width: 2;
}

.import-product-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.import-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.import-field label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}

.import-field input {
  padding: 10px 12px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s;
  background: white;
}

.import-field input:focus {
  outline: none;
  border-color: #0A5C6B;
  box-shadow: 0 0 0 3px rgba(10, 92, 107, 0.1);
}

.category-search-container {
  position: relative;
}

.category-search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon-sm {
  position: absolute;
  left: 10px;
  width: 16px;
  height: 16px;
  stroke: #94a3b8;
  stroke-width: 2;
  z-index: 1;
}

.category-search-input-wrapper input {
  width: 100%;
  padding: 10px 36px 10px 34px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s;
  background: white;
}

.category-search-input-wrapper input:focus {
  outline: none;
  border-color: #0A5C6B;
  box-shadow: 0 0 0 3px rgba(10, 92, 107, 0.1);
}

.clear-category-btn {
  position: absolute;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: none;
  background: #f1f5f9;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.clear-category-btn:hover {
  background: #e2e8f0;
}

.clear-category-btn svg {
  width: 14px;
  height: 14px;
  stroke: #64748b;
  stroke-width: 2;
}

.category-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  max-height: 180px;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 1000;
}

.category-option {
  padding: 10px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.15s;
  border-bottom: 1px solid #f1f5f9;
}

.category-option:last-child {
  border-bottom: none;
}

.category-option:hover {
  background: #f8fafc;
}

.category-option.selected {
  background: #f0f9ff;
}

.category-name {
  font-size: 14px;
  color: #0f172a;
  font-weight: 500;
}

.check-icon-sm {
  width: 16px;
  height: 16px;
  stroke: #0A5C6B;
  stroke-width: 2.5;
}

.field-error-sm {
  font-size: 11px;
  color: #dc2626;
  font-weight: 500;
}

.currency-input-sm {
  position: relative;
  display: flex;
  align-items: center;
}

.currency-input-sm input {
  width: 100%;
  padding: 10px 50px 10px 12px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  text-align: right;
  transition: all 0.2s;
  background: white;
}

.currency-input-sm input:focus {
  outline: none;
  border-color: #0A5C6B;
  box-shadow: 0 0 0 3px rgba(10, 92, 107, 0.1);
}

.currency-suffix {
  position: absolute;
  right: 10px;
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  pointer-events: none;
}

.import-modal-actions {
  border-top: 1px solid #e2e8f0;
  padding: 20px 24px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.import-modal-actions .modal-btn.primary {
  display: flex;
  align-items: center;
  gap: 8px;
}

.import-modal-actions .modal-btn.primary svg {
  width: 18px;
  height: 18px;
  stroke-width: 2;
}

/* Responsive for import modal */
@media (max-width: 768px) {
  .import-modal {
    max-width: 100%;
    margin: 10px;
    max-height: 95vh;
  }

  .import-product-grid {
    grid-template-columns: 1fr;
  }

  .modal-header.info {
    flex-wrap: wrap;
  }

  .import-modal-actions {
    flex-direction: column;
  }

  .import-modal-actions .modal-btn {
    width: 100%;
  }
}
</style>